<script>
import BaseCollectorPublicationImportKimsModal from '@/components/admin/collector/publications/BaseCollectorPublicationImportKimsModal.vue'

export default {
  extends: BaseCollectorPublicationImportKimsModal,
}
</script>
